import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import type { ReactNode } from "react";

interface RadioItem {
  value: string;
  name: string;
}

interface Props {
  value?: string | null;
  isCheckBox?: boolean;
  radioButtonList?: RadioItem[] | null;
  handleRadioButtonChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children?: ReactNode;
}

const SbuxRadioGroup = ({
  value = null,
  isCheckBox = false,
  radioButtonList = null,
  handleRadioButtonChange,
  children = null,
}: Props) => {
  return (
    <FormControl>
      <RadioGroup row value={value} onChange={handleRadioButtonChange}>
        {children
          ? children
          : radioButtonList &&
            radioButtonList.length > 0 &&
            radioButtonList.map((item, index) => (
              <FormControlLabel
                sx={{ fontSize: 14 }}
                key={index}
                value={item.value}
                control={
                  isCheckBox ? (
                    <Checkbox size="small" />
                  ) : (
                    <Radio size="small" sx={{ padding: "4px" }} />
                  )
                }
                label={<Box sx={{ fontSize: 14 }}>{item.name}</Box>}
              />
            ))}
      </RadioGroup>
    </FormControl>
  );
};

export default SbuxRadioGroup;
